<template>
  <div class="input-group">
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12">
        <v-select
          class="m-auto"
          v-model="property.schedule"
          :items="scheduleList"
          item-text="name"
          item-value="schedule_id"
          label="Check schedule"
          dense
          hide-details
        ></v-select>
      </v-col>
    </v-row>

    <hr class="note-divider" />
    <note-component :node="node" />
  </div>
</template>

<script>
import NoteComponent from '../../../components/note'
import apiSchedule from '@/apis/schedule'

export default {
  props: {
    node: Object
  },
  components: {
    NoteComponent
  },
  watch: {
    'property.schedule': {
      handler(value) {
        const item = this.scheduleList.find(e => e.schedule_id == value)
        if (item) {
          this.node.name = item.name
          this.property.schedule_name = item.name
        }
      }
    }
  },
  data() {
    return {
      property: {},
      scheduleList: []
    }
  },
  created() {
    this.property = this.node.property
    this.initial()
  },
  methods: {
    async initial() {
      await this.getSchedules()
    },
    async getSchedules() {
      try {
        const getSchedules = await apiSchedule.getSchedules()
        const { data } = getSchedules
        this.scheduleList = []
        for (const obj of data) {
          this.scheduleList.push({
            schedule_id: obj.schedule_id,
            name: obj.name
          })
        }
        this.scheduleList.sort((a, b) => (a.name > b.name ? 1 : -1))
      } catch {}
    }
  }
}
</script>
